'use client'

import { WidgetType } from '@lastbrand/storefront-proto-registry/api/v1/enums'

import { PLBaseErrorBoundary } from '@src/components/pl-base-error-boundary'
import { PLTypedWidgetInterface, PLTypedWidgetProps } from '@src/components/pl-base-widget'
import { HonestReviewsV2 } from '@src/SectionRenderer/sections/honestReviewsV2/HonestReviewsV2'

import { buildHonestReviewsConfig, childrenToReviews } from '../honest-reviews-section-builders'

import type { HonestReviewsWidgetData } from '@lastbrand/storefront-proto-registry/api/v1/widget'

const HonestReviewsWidgetComponent = (props: PLTypedWidgetProps<HonestReviewsWidgetData>) => {
  const data = (props.data as { honestReviewsData?: HonestReviewsWidgetData } | undefined)?.honestReviewsData
  const reviews = childrenToReviews(props.children)
  if (!data || !reviews.length) return null

  return <HonestReviewsV2 sectionConfig={buildHonestReviewsConfig(data, reviews)} />
}

export const HonestReviewsWidget: PLTypedWidgetInterface<HonestReviewsWidgetData, WidgetType.HONEST_REVIEWS> = {
  id: WidgetType.HONEST_REVIEWS,
  errorBoundary: PLBaseErrorBoundary,
  render: HonestReviewsWidgetComponent,
}
